import React from 'react';
import CloseIcon from '@material-ui/icons/Close';
import {
	Button,
	CircularProgress,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	IconButton,
	makeStyles,
	Typography,
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
	header: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
	},
	buttonLarge: {
		padding: `${theme.spacing(0.5)}px ${theme.spacing(6)}px`,
		height: 40,
	},
}));

const BaseModal = ({
	mainText,
	open,
	onClose,
	onConfirm,
	confirmLabel = 'Aceptar',
	onCancel,
	cancelLabel = 'Cancelar',
	maxWidth = 'sm',
	children,
	onCloseButton = true,
	color = 'primary',
	confirmVariant = 'contained',
	cancelVariant = 'text',
	disableOnConfirm = false,
}) => {
	const classes = useStyles();

	if (!open) return <></>;
	const handleClose = (event, reason) => {
		if (reason === 'backdropClick') {
			return;
		}
		onClose();
	};

	return (
		<Dialog
			open={open}
			fullWidth={true}
			onClose={handleClose}
			maxWidth={maxWidth}
			PaperProps={{
				elevation: 1,
			}}
			TransitionProps={{
				style: {
					backgroundColor: 'rgb(0 0 0 / 50%)',
				},
			}}
		>
			<DialogTitle className={classes.header} disableTypography={true}>
				<Typography variant="h5"></Typography>
				<h1 className="text-center">{mainText}</h1>
				<IconButton
					disabled={disableOnConfirm}
					style={{ display: onCloseButton ? 'flex' : 'none' }}
					className={classes.closeButton}
					onClick={onClose}
				>
					<CloseIcon />
				</IconButton>
			</DialogTitle>
			<DialogContent>{children}</DialogContent>
			{onCancel || onConfirm ? (
				<DialogActions
					className={`pt-4 d-flex justify-content-${
						onCancel && onConfirm ? 'between' : 'end'
					}`}
				>
					{onCancel ? (
						<Button
							className={classes.buttonLarge}
							disableElevation
							color={color}
							variant={cancelVariant}
							disabled={disableOnConfirm}
							onClick={onCancel}
						>
							{cancelLabel}
						</Button>
					) : null}
					{onConfirm ? (
						<Button
							disabled={disableOnConfirm}
							color={color}
							disableElevation
							variant={confirmVariant}
							className={classes.buttonLarge}
							onClick={onConfirm}
							endIcon={disableOnConfirm && <CircularProgress size={18} />}
						>
							{confirmLabel}
						</Button>
					) : null}
				</DialogActions>
			) : null}
		</Dialog>
	);
};

export default BaseModal;
